module.exports = __webpack_public_path__ + "static/media/bloco5img3.03b23f65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/EVisual/bloco5img3.jpg
// module id = 140
// module chunks = 0